import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import Select from 'components/shared/Select/Select';
import Typography from 'components/shared/Typography/Typography';

import { NDC_CODE_TYPES } from './lib/helpers';
import handleNdcSearch from './lib/handleNdcSearch';

const NdcCodeModal = ({ isOpen, initialCodes, type, onClose, onSave }) => {
  const [selectedNdcCodes, setSelectedNdcCodes] = useState(initialCodes);
  const [selectedType, setSelectedType] = useState(type);
  const navigate = useNavigate();

  const handleSave = () => {
    onSave(selectedNdcCodes, selectedType);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      disableHeader
      className="max-w-[480px]"
      bodyClassName="p-0 overflow-hidden"
      footer={
        <div className="flex flex-1 justify-between gap-2">
          <Button text="Cancel" onClick={onClose} variant="tertiary" size="small" />
          <Button
            text="Add NDC code"
            isDisabled={selectedNdcCodes.length === 0}
            onClick={handleSave}
            size="small"
          />
        </div>
      }>
      <div className="flex h-12 items-center justify-between gap-1.5 bg-white px-4 py-0">
        <div className="flex items-center gap-1.5">
          <Icon icon="search-filled" color="primary" />
          <Typography weight="medium" className="neutral-800">
            NDC codes
          </Typography>
        </div>
        <Icon icon="close-linear" onClick={onClose} size={14} />
      </div>

      <div className="h-fit overflow-y-auto p-4">
        <div className="flex flex-col gap-2">
          <Select
            label="Type"
            value={NDC_CODE_TYPES.find((item) => item?.value === (selectedType || 'package_ndc'))}
            isClearable={false}
            options={NDC_CODE_TYPES}
            menuPortalTarget={document.body}
            onChange={(event) => setSelectedType(event?.value)}
          />
          <Select
            label="NDC code"
            value={selectedNdcCodes}
            isAsync
            cacheOptions
            placeholder="Start typing an NDC code or other category"
            isClearable={false}
            noOptionMessage={() => 'Start typing an NDC code or other category'}
            onChange={(event) => {
              setSelectedNdcCodes(
                event.map((item) => {
                  return {
                    label: item?.value,
                    value: item?.value,
                    title: item?.title || item?.label
                  };
                })
              );
            }}
            loadOptions={(searchTerm) =>
              handleNdcSearch({ searchTerm, navigate, searchType: selectedType })
            }
            isMulti={true}
            menuPortalTarget={document.body}
          />
        </div>
      </div>
    </Modal>
  );
};

export default NdcCodeModal;
